import React, {Component} from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import firebaseInit from 'firebase-init';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {checkIfFullscreen, toggleFullscreen} from 'helpers/fullscreen-helper';
import Loading from './loading/loading';
import AdminLoginController from 'components/admin/admin-login-controller';
import Auth from './login/auth';
import LandingPage from 'components/landing-page/landing-page';
import './app.css';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFullscreen: false,
			isLoading: true,
			companies: []
		};
	}

	/* Component mounted */
	componentDidMount = () => {
		/* Initialize firebase */
		firebaseInit();

		this.getCompanies().then((response) => {
			this.setState({isLoading: false});
		});

		/* Fullscreen listeners */
		document.removeEventListener('webkitfullscreenchange', this.updateFullscreenStatus, false);
		document.removeEventListener('mozfullscreenchange', this.updateFullscreenStatus, false);
		document.removeEventListener('fullscreenchange', this.updateFullscreenStatus, false);
		document.removeEventListener('MSFullscreenChange', this.updateFullscreenStatus, false);
	};

	/**
	 * Component will unmount
	 */
	componentWillUnmount() {
		document.removeEventListener('webkitfullscreenchange', this.updateFullscreenStatus, false);
		document.removeEventListener('mozfullscreenchange', this.updateFullscreenStatus, false);
		document.removeEventListener('fullscreenchange', this.updateFullscreenStatus, false);
		document.removeEventListener('MSFullscreenChange', this.updateFullscreenStatus, false);
	}


	/**
	 * Subscribe to companies
	 */
	getCompanies = () => {
		const db = firebase.firestore();
		return new Promise((resolve)=>{
			db.collection('companies').get().then((docs) => {
				let companies = [];
				docs.forEach((doc) => {companies.push({...doc.data(), id: doc.id});});
				this.setState({companies}, () => {resolve({status: 'success'});});
			}, (error) => {
				console.error('could not get companies: ', error);
				resolve({status: 'error', error: error});
			});
		});
	};

	/**
	 * Toggle full screen
	 */
	handleToggleFullscreen = () => {
		let isFullscreen = toggleFullscreen();
		this.setState({isFullscreen: isFullscreen});
	};
	updateFullscreenStatus = () => {
		let isFullscreen = checkIfFullscreen();
		this.setState({isFullscreen: isFullscreen});
	};

	/* Render app */
	render = () => {
		if (this.state.isLoading) {
			return (
				<div className="App" id="app">
					<Loading />
				</div>
			);
		};

		return (
			<div className="App" id="app">
				<BrowserRouter>
					<Routes>
						<Route path="/admin" element={<AdminLoginController />} />
						<Route 
							path="/:companyUrl?/crm-aeroplanes"
							element={
								<Auth 
									gameType="crm-aeroplanes" 
									companies={this.state.companies}
									isFullscreen={this.state.isFullscreen}
									handleToggleFullscreen={this.handleToggleFullscreen}
								/>
							}
						/>
						<Route 
							path="/:companyUrl?/crm-helicopters"
							element={
								<Auth 
									gameType="crm-helicopters" 
									companies={this.state.companies}
									isFullscreen={this.state.isFullscreen}
									handleToggleFullscreen={this.handleToggleFullscreen}
								/>
							}
						/>
							
						
						<Route 
							path="/:companyUrl?/humanfactorstraining"
							element={
								<Auth 
									gameType="safetytraining" 
									companies={this.state.companies}
									isFullscreen={this.state.isFullscreen}
									handleToggleFullscreen={this.handleToggleFullscreen}
								/>
							}
						/>
						{this.state.companies.map((company) => {
							if (company.loginConfig && company.loginConfig.url) {
								return (
									<Route 
										key={company.id}
										path={'/' + company.loginConfig.url}
										element={<LandingPage company={company} />} 
									/>
								);
							} 
							return null;
						})}
						<Route path="*" element={<LandingPage />} />
					</Routes>
				</BrowserRouter>
			</div>
		);
	};
}

export default App;